import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Checkbook  {
    _originalTypeClassName = "zERP.BO.Checkbook";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Checkbook.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.BankAccount = new Domain.BankAccount();
this.Checks = [];
this.CheckNumbers = [];
this.Id = null;
this.Code = null;
this.Description = null;
this.DateCreated = null;
this.Manuscript = false;
this.IsFinalized = false;
this.IsCompleted = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Description:any;
DateCreated:any;
Manuscript:any;
IsFinalized:any;
IsCompleted:any;
Entity:any;
BankAccount:any;
Checks:any;
CheckNumbers:any;
LastCheckNumber:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setBankAccount = ($this, value) => {
var oldValue = $this.BankAccount;
$this.BankAccount = value;
if (value != null) {
}
}
static setChecks = ($this, items) => {
                if (items == null) items = [];
                if ($this.Checks == null) $this.Checks = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Checks.length > 0) {
                    Domain.Checkbook.removeChecks($this, $this.Checks[0]);
                }

                Domain.Checkbook.addManyChecks($this, copyItems);
            }
static addManyChecks = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Checkbook.addChecks($this, items[i]);
                }
            }
static addChecks = ($this, item) => {
                if ($this.Checks == null) $this.Checks = [];
                if (item == null || $this.Checks.indexOf(item) > -1) return;
                $this.Checks.push(item);
if (item.Checkbook != $this) {
Domain.Check.setCheckbook(item, $this);
}
}
static addRangeChecks = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Checkbook.addChecks($this, item));
            }
static removeChecks = ($this, item) => {
                if ($this == null || $this.Checks == null || $this.Checks.indexOf(item) === -1) return;
                var _index = $this.Checks.indexOf(item);
                $this.Checks.splice(_index, 1);
item.Checkbook = null;
}
static clearChecks = ($this) => { $this.Checks = null; }
static setCheckNumbers = ($this, items) => {
                if (items == null) items = [];
                if ($this.CheckNumbers == null) $this.CheckNumbers = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CheckNumbers.length > 0) {
                    Domain.Checkbook.removeCheckNumbers($this, $this.CheckNumbers[0]);
                }

                Domain.Checkbook.addManyCheckNumbers($this, copyItems);
            }
static addManyCheckNumbers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Checkbook.addCheckNumbers($this, items[i]);
                }
            }
static addCheckNumbers = ($this, item) => {
                if ($this.CheckNumbers == null) $this.CheckNumbers = [];
                if (item == null || $this.CheckNumbers.indexOf(item) > -1) return;
                $this.CheckNumbers.push(item);
}
static addRangeCheckNumbers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Checkbook.addCheckNumbers($this, item));
            }
static removeCheckNumbers = ($this, item) => {
                if ($this == null || $this.CheckNumbers == null || $this.CheckNumbers.indexOf(item) === -1) return;
                var _index = $this.CheckNumbers.indexOf(item);
                $this.CheckNumbers.splice(_index, 1);
}
static clearCheckNumbers = ($this) => { $this.CheckNumbers = null; }
static setLastCheckNumber = ($this, value) => {
var oldValue = $this.LastCheckNumber;
$this.LastCheckNumber = value;
if (value != null) {
}
}

static AddCheckbookNumber($this: any): any{let newCheckNumber = new Domain.CheckbookCheckNumber();
newCheckNumber.Order = 0;
if (CLMS.Framework.Number.GreaterThan(() => $this.CheckNumbers.length, () => 0)) {newCheckNumber.Order = Joove.Common.safeNumber($this?.CheckNumbers?.linq?.select((x) => x?.Order)?.max()) + Joove.Common.safeNumber(1);}
newCheckNumber.IsUsed = false;
newCheckNumber.CheckNumber = "";
$this?.CheckNumbers?.add(newCheckNumber);
}
static RemoveCheckbookNumber($this: any, number: any): any{$this?.CheckNumbers?.splice($this?.CheckNumbers.indexOf(number), 1);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}